import { css } from '@emotion/react';
import { useTranslation, Trans } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Modal, ModalControlModalProps, Text } from '@frontend/design-system';
import { AiReceptionistTrackingIds } from '../../../tracking-ids';

export type AiInstructionInfoModalProps = ModalControlModalProps;

export const AiInstructionInfoModal = ({ show, onClose }: AiInstructionInfoModalProps) => {
  const { t } = useTranslation('ai-receptionist-settings');

  return (
    <Modal show={show} onClose={onClose} maxWidth={600}>
      <Modal.Header onClose={onClose} closeBtnTrackingId={AiReceptionistTrackingIds.infoModalCloseButton}>
        {t('What is this information used for?')}
      </Modal.Header>
      <Modal.Body css={styles.body}>
        <Text size='medium'>
          <Trans t={t}>
            AI Receptionist will follow its <strong>workflow instructions</strong> to perform and complete daily tasks.
            When managing text messages and calls, your AI Receptionist relies on its <strong>knowledge base</strong> to
            deliver accurate and helpful responses to the various questions that may be asked about your business.
            Everything in the AI Receptionist's knowledge base has the potential to be disclosed during conversations.
          </Trans>
        </Text>
        <Text size='medium'>
          <Trans t={t}>
            Incomplete or missing information may limit the AI Receptionist's understanding and result in your AI asking
            for help from you and your team more frequently.
          </Trans>
        </Text>
      </Modal.Body>
      <Modal.Footer
        secondary={{
          label: t('Close'),
          onClick: onClose,
          trackingId: AiReceptionistTrackingIds.infoModalCloseButton,
        }}
      />
    </Modal>
  );
};

const styles = {
  body: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(3)};
  `,
};
